import { ColorValues, RgbColor, ColorShifts } from "@/shared/types";
import _ from "lodash";

function zeroCheck (value: number): number {
  return value === 0 ? 1 : value;
}

export function shade (red: number, green: number, blue: number, shadeFactor: number): RgbColor {
  const zeroCheckRed = zeroCheck(red);
  const zeroCheckGreen = zeroCheck(green);
  const zeroCheckBlue = zeroCheck(blue);

  const newR = _.floor(zeroCheckRed * (1 - shadeFactor));
  const newG = _.floor(zeroCheckGreen * (1 - shadeFactor));
  const newB = _.floor(zeroCheckBlue * (1 - shadeFactor));

  return { r: newR, g: newG, b: newB };
}

export function tint (red: number, green: number, blue: number, tintFactor: number): RgbColor {
  const zeroCheckRed = zeroCheck(red);
  const zeroCheckGreen = zeroCheck(green);
  const zeroCheckBlue = zeroCheck(blue);

  const newR = _.floor(zeroCheckRed + (255 - zeroCheckRed) * tintFactor);
  const newG = _.floor(zeroCheckGreen + (255 - zeroCheckGreen) * tintFactor);
  const newB = _.floor(zeroCheckBlue + (255 - zeroCheckBlue) * tintFactor);

  return { r: newR, g: newG, b: newB };
}

export function getColorShifts (color: string): ColorShifts {
  const rgbColor = covertHexToRgbColor(color);

  return {
    light: convertColorToHex(tint(rgbColor.r, rgbColor.g, rgbColor.b, 0.2)),
    lighter: convertColorToHex(tint(rgbColor.r, rgbColor.g, rgbColor.b, 0.4)),
    lightest: convertColorToHex(tint(rgbColor.r, rgbColor.g, rgbColor.b, 0.6)),
    dark: convertColorToHex(shade(rgbColor.r, rgbColor.g, rgbColor.b, 0.25)),
    darker: convertColorToHex(shade(rgbColor.r, rgbColor.g, rgbColor.b, 0.5)),
    darkest: convertColorToHex(shade(rgbColor.r, rgbColor.g, rgbColor.b, 0.75))
  };
}

export function formatStyleString (colorValues: ColorValues, fontFace: string, buttonBorderRadius: number): string {
  let styleString = `${fontFace};`;
  styleString += `--border-radius: ${buttonBorderRadius}px;`;
  _.forIn(colorValues, (value, key) => {
    styleString += `--color-${key}: ${value};`;
    const colorShifts = getColorShifts(value);
    _.forIn(colorShifts, (color, name) => {
      styleString += `--color-${key}-${name}: ${color};`;
    });
  });
  return styleString;
}

export function convertColorToHex (color: RgbColor): string {
  const result = "#" + [_.floor(color.r), _.floor(color.g), _.floor(color.b)].map(x => {
    const hex = x.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }).join("");

  return result;
}

export function covertHexToRgbColor (hex: string): RgbColor {
  const value = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
              , (m, r, g, b) => "#" + r + r + g + g + b + b)
      .substring(1).match(/.{2}/g)
      .map(x => parseInt(x, 16));

    return { r: value[0], g: value[1], b: value[2] };
}
